import type { FC } from 'react';

export const SkyvernLogo: FC<{ className?: string }> = ({ className }) => (
  <div className={className ?? 'w-8 h-8 flex items-center justify-center'}>
    <img
      src="/skyvern-logo.png"
      alt="Skyvern"
      className="w-full h-full object-contain"
    />
  </div>
);
